'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makeGeoChart', require('./makegeochart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/geochart/index.js
 **/